import axios from '@/plugins/axios'

const destroyGroup = async id => {
  try {
    const response = await axios.post(`groups/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get specific group
 *
 * @param {*} slug
 * @returns
 */
const getGroup = async slug => {
  try {
    const response = await axios.get(`groups/${slug}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get groups
 *
 * @param {*} param0
 * @returns
 */
const getGroups = async ({
  userId = null,
  categoryId = null,
  genreId = null,
  visibility = null,
  search = null,
  isPublicDomain = null,
  itemsPerPage = 9,
  isPaid = null,
  page = 1,
  sort = null,
  orderBy = null
}) => {
  try {
    const params = {}
    if (userId) params.user_id = userId
    if (search) params.search = search
    if (sort) params.sort = sort
    if (orderBy) params.order_by = orderBy
    if (isPaid !== null) params.is_paid = isPaid ? 1 : 0
    params.items_per_page = itemsPerPage
    params.page = page

    const response = await axios.get('groups', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get groups a user is member
 *
 * @param {*} param0
 * @returns
 */
const getGroupsMemberships = async ({
  userId,
  page = 1,
  sort = null,
  orderBy = null
}) => {
  try {
    const params = {}
    if (userId) params.user_id = userId
    params.page = page

    const response = await axios.get('groups/memberships', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get members of group
 *
 * @param {*} id
 * @returns
 */
const getMembers = async ({
  id,
  page = 1
}) => {
  try {
    const response = await axios.get('groups/members', {
      params: {
        group_id: id,
        page: page
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Create/edit group
 *
 * @param {*} id
 * @param {*} param1
 * @returns
 */
const post = async (id = null, {
  type,
  name,
  slug,
  description = '',
  amount = 0,
  visibility,
  // eslint-disable-next-line camelcase
  is_public_posting_enabled = false,
  tags = [],
  cover = null
}) => {
  try {
    // console.log(type, name, slug, description, amount, visibility, tags, cover)
    const form = new FormData()
    form.append('name', name)
    // eslint-disable-next-line camelcase
    form.append('is_public_posting_enabled', is_public_posting_enabled ? 1 : 0)
    form.append('visibility', visibility)
    form.append('slug', slug)
    form.append('type', type)
    if (description) form.append('description', description)
    if (cover) form.append('cover', cover)
    if (tags) form.append('tags', tags)
    if (amount) form.append('amount', parseInt(amount * 100))
    if (id) form.append('_method', 'PUT')
    const url = id ? `groups/${id}` : 'groups'
    const response = await axios.post(url, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    console.log(error)
    return Promise.reject(error)
  }
}

/**
 * Remove specified user from group
 *
 * @param {*} id
 */
const removeUserFromGroup = async ({
  groupId,
  userId
}) => {
  try {
    const params = {
      group_id: groupId,
      user_id: userId,
      _method: 'DELETE'
    }
    const response = await axios.post('groups/members', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Toggle membership of group
 *
 * @param {*} param0
 * @returns
 */
const toggleMembership = async ({
  groupId,
  action
}) => {
  try {
    const params = {
      group_id: groupId
    }
    const url = action === 'leave' ? 'groups/leave' : 'groups/join'
    const response = await axios.post(url, params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroyGroup,
  getGroup,
  getGroups,
  getGroupsMemberships,
  getMembers,
  post,
  removeUserFromGroup,
  toggleMembership
}
